import { render, staticRenderFns } from "./beSettledRule.vue?vue&type=template&id=2c7ec852&scoped=true&"
import script from "./beSettledRule.vue?vue&type=script&lang=js&"
export * from "./beSettledRule.vue?vue&type=script&lang=js&"
import style0 from "./beSettledRule.vue?vue&type=style&index=0&id=2c7ec852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7ec852",
  null
  
)

export default component.exports